const getProductInventoryChannels = (serverInventory) => {
  return serverInventory?.items?.map((serverInventoryItem) => ({
    key: serverInventoryItem.channel.key,
    id: serverInventoryItem.channel.id,
    quantity: serverInventoryItem.quantity
  }));
};
export {
  getProductInventoryChannels
};
//# sourceMappingURL=get-product-inventory-channels.js.map
